import { render, staticRenderFns } from "./ManageProduct.vue?vue&type=template&id=48be5cd8&"
import script from "./ManageProduct.vue?vue&type=script&lang=js&"
export * from "./ManageProduct.vue?vue&type=script&lang=js&"
import style0 from "./ManageProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports